import daysBetween from './daysBetween';

export default function manuscriptOverdue(manuscript) {
  const timeElapsed = daysBetween(manuscript.timeUpdated, new Date());
  const overdueDays = 60;
  return timeElapsed >= overdueDays;
}
